<template>
  <div class="app">
    <div class="pc-container">
        <div class="pageleft">
            <div class="banner">
              <img src="../../src/static/img/bannberpc.png" alt="">
            </div>
        </div>
        <div class="pageright com-center">
          <ul>
            <li class="first-row">
              <div class="logo">
                <img src="../../src/static/img/P3LOGOPC.png" alt="">
              </div>
            </li>
            <li class="second-row com-center">
              <div class ="link com-center">
                <div class="linkrow com-flex-row com-center">
                  <div class="columnleft com-center">
                    {{ convertDomain(urlViewList[0]) }}
                  </div>
                  <div class="com-flex-right com-center"  @click="toUrlLink('link',0)">
                    <div class="tourlbtn com-center">Truy cập</div>
                    <!--                      <div class="tourlbtn com-center">Truy cập</div>-->
                  </div>
                </div>
              </div>

              <div class ="link com-center" @click="toUrlLink('link',1)">
                <div class="linkrow com-flex-row com-center">
                  <div class="columnleft com-center">
                    {{ convertDomain(urlViewList[1]) }}
                  </div>
                  <div class="com-flex-right com-center">
                    <div class="tourlbtn com-center">Truy cập</div>
                  </div>
                </div>
              </div>
            </li>
            <li class="second-row com-center">
              <div class ="link com-center" @click="toUrlLink('link',2)">
                <div class="linkrow com-flex-row com-center">
                  <div class="columnleft com-center">
                    {{ convertDomain(urlViewList[2]) }}
                  </div>
                  <div class="com-flex-right com-center">
                    <div class="tourlbtn com-center">Truy cập</div>
                  </div>
                </div>
              </div>

              <div class ="link com-center" @click="toUrlLink('link',3)">
                <div class="linkrow com-flex-row com-center">
                  <div class="columnleft com-center">
                    {{ convertDomain(urlViewList[3]) }}
                  </div>
                  <div class="com-flex-right com-center">
                    <div class="tourlbtn com-center">Truy cập</div>
                  </div>
                </div>
              </div>
            </li>
            <li class="second-row com-center">
              <div class ="link com-center" @click="toUrlLink('link',4)">
                <div class="linkrow com-flex-row com-center">
                  <div class="columnleft com-center">
                    {{ convertDomain(urlViewList[4]) }}
                  </div>
                  <div class="com-flex-right com-center">
                    <div class="tourlbtn com-center">Truy cập</div>
<!--                      <div class="tourlbtn com-center">Truy cập</div>-->
                  </div>
                </div>
              </div>

              <div class ="link com-center" @click="toUrlLink('link',5)">
                <div class="linkrow com-flex-row com-center">
                  <div class="columnleft com-center">
                    {{ convertDomain(urlViewList[5]) }}
                  </div>
                  <div class="com-flex-right com-center">
                    <div class="tourlbtn com-center">Truy cập</div>
                  </div>
                </div>
              </div>
            </li>
            <li class="footpc-row com-center">
              <div class ="link com-center" @click="toUrlLink('download',0)">
                <div class="approw com-flex-row com-center">
                  <img src="../../src/static/img/PCxiazai.png" alt="">
                  TẢI APP
                </div>
              </div>

              <div class ="link com-center" @click="toUrlLink('kefu',0)">
                <div class="kefurow com-flex-row com-center">
                  <img src="../../src/static/img/PCkefu.png" alt="">
                  CSKH ONLINE 24/7
                </div>
              </div>
            </li>



<!--            <li class="footer-row com-center">-->
<!--              <div class="linkrow com-flex-row com-center" @click="toUrlLink('download',0)">-->
<!--                <img src="../../src/static/img/appDpc.png" alt="">-->
<!--              </div>-->
<!--              <div class="linkrow com-flex-row com-center" @click="toUrlLink('kefu',0)">-->
<!--                <img src="../../src/static/img/custSpc.png" alt="">-->
<!--              </div>-->
<!--            </li>-->

            <li class="footer-row com-center">
              <img src="../../src/static/img/miaoshupc.png" alt="">
            </li>
          </ul>
        </div>

<!--      <div class="footer">-->
<!--        Copyright © 2024 t123.com All Rights Reserved-->
<!--      </div>-->
    </div>

  </div>
<!--  </div>-->
</template>

<script>
import urlListJson from "@/static/js/urllist.json"
export default {
  data() {
    return {
      value: '',
      value1: true,
      errorMessage:'Trang Web an toàn',
      urlList:[],
      urlList2:['https://8736.com/','http://7520d.com/'],
      urlViewList:urlListJson.urlViewList, //展示域名
      accessResults: {},
      androidUrl: undefined,
      iosUrl: undefined,
      kefuUrl: undefined,
      webUrl: undefined,
      okurl: undefined //可访问域名
    }
  },
  mounted(){
    // this.urlList = this.fisherYatesShuffle([...urlListJson.urlList]);
    this.webUrl = urlListJson.web
    this.androidUrl = urlListJson.android
    this.iosUrl = urlListJson.ios
    this.kefuUrl = urlListJson.kefu
    // this.checkUrls();
    this.recordAccess()
  },
  methods: {
    recordAccess() {
      // 使用fetch调用，静默处理所有结果
      fetch('/log.php')
          .then(response => {
            // 静默处理成功响应
            // console.log('访问日志记录成功');
          })
          .catch(error => {
            // 静默处理错误
            // console.log('访问日志记录失败（已静默处理）');
          });
    },
    fisherYatesShuffle(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]; // 交换位置
      }
      console.log("打乱顺序后："+array)
      return array;
    },
    toUrlLink(type,index){

      console.log(type)
      if('link' === type){
        // console.log(urlListJson.urlList[index])
        window.location.href = urlListJson.urlList[index];
            // this.urlViewList[index];
      }else if('download' === type){
        window.location.href = this.webUrl;
      }else if('kefu' === type){
        window.location.href = this.kefuUrl;
      }
    },
    convertDomain(url) {
      if(url){
        const domain = url.replace(/https?:\/\/(www\.)?/, '').replace(/\/.*$/, '');
        return domain.toUpperCase();
      }else{
        return "";
      }
    },
    async checkUrls() {
      console.log("111111111")
      for (const url of this.urlList) {
        try {
          const response = await fetch(url, {
            method: 'HEAD', // 只请求头部，不下载整个页面
            mode: 'no-cors', // 避免 CORS 问题，适用于测试
          });

          // if (response.ok) {
          //   console.log("链接正常："+url)
          //   this.status = '链接可访问';
          //   console.log("链接正常："+this.status)
          // } else {
          //   console.log("链接正常111："+url)
          //   this.status = `链接不可访问，状态码: ${response.status}`;
          //   console.log("链接正常111："+this.status)
          // }
          this.okurl = url;
          console.log("链接正常："+url)
          return
          // 如果不是报错则说明域名是正常的,正常访问即可
          // 根据当前域名执行不同的操作
          // window.location.href = url; // 跳转到另一个域名
          // return
        } catch (error) {
          // 下面这种是无法解析的情况，如果无法解析则说明无法访问
          console.log("链接不正常："+url)
        }
      }
    }
  }
}
</script>


<style>



.app {
  position: relative; /* 确保伪元素定位相对于主容器 */
  width: 100%;
  height: 100vh; /* 设置容器高度 */
  background-color: #F6FBFF; /* 背景色 */
  display: flex; /* 可以用来做布局 */
  justify-content: center;
}

.app::before {
  content: ""; /* 必须设置内容属性 */
  position: absolute; /* 绝对定位以覆盖容器 */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(../../src/static/img/pc_bg.png) no-repeat center center; /* 背景图 */
  background-size: cover; /* 确保背景图铺满容器 */
  opacity: 0.5; /* 设置透明度为50% */
  z-index: 0; /* 确保伪元素在底部 */
}

.app > * {
  position: relative; /* 确保容器内的内容在最上层 */
  z-index: 1; /* 设置主内容的z-index，使其高于背景 */
}

.pc-container {
  display: flex;
  //background: url(../../src/static/img/bg.png) no-repeat;
  //background-size: cover;
}

/**左侧*/
.pc-container .pageleft{
  width: 600px;
  height:100vh;
  display: flex;
  justify-content: end;
  align-items: center;
}
.banner img {
  width:6rem
}
/**右侧*/
.pc-container .pageright{
  width: 1000px;
  height:100vh;
}

ul {
  list-style-type: none;
  padding: 0;
  margin:  0;
  width: 100%;
}
.first-row {
  text-align: center;
  width: 100%;
  margin-bottom: 20px; /* 给第一行和第二行之间留一些空间 */
}
.first-row .logo img{
  width: 182px;
}


.second-row {
  display: flex;
  width: 100%;
}
.link{
  margin: .1rem 0;
  width: 50%;
  text-align: center;
}

.second-row .linkrow{
  background: #FFFFFF;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.25);
  border-radius: 9px;
  border: 1px solid #78cff9;
  width: 460px;
  height: 62px;
}

.second-row .linkrow .columnleft{
  width: 80%;
  height: 66px;
  font-size: 21px;
}


.footpc-row {
  display: flex;
  width: 100%;
}
.footpc-row img{
  width: 28px;
  margin-right: 10px;
}

.footpc-row .approw{
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.25);
  border-radius: 9px;
  border: 1px solid #78cff9;
  width: 460px;
  height: 62px;
  background: linear-gradient(to right, #FFFFFF 0%, #DEEDFB 47%, #61CEFF 100%);
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #1B75F0;
  mix-blend-mode: normal;
}


.footpc-row .kefurow{
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.25);
  border-radius: 9px;
  border: 1px solid #78cff9;
  width: 460px;
  height: 62px;
  background: linear-gradient(to right, #61CFFF, #1B75F0);
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #FFFFFF;
  mix-blend-mode: normal;
}

.footer-row {
  display: flex;
  width: 100%;
}
.footer-row img {
  margin-top: 20px;
  width: 100%;
}


.footer-row .linkrow{
  margin: .1rem 0;
  width: 50%;
  text-align: center;
}
.footer-row .linkrow img{
  width: 486px;
  height: 92px;
}


.pc-container .footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  text-align: center;
}



.com-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.com-flex-row {
  display: flex;
  flex-direction: row;
}
.com-flex-right {
  display: flex;
  flex: 1;
  justify-content: flex-end !important;
}


.pc-container .linkrow .tourlbtn {
  background: linear-gradient(to right, #61CFFF, #1B75F0);
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 23px;
  text-align: center;
  color: #FFFFFF;
  mix-blend-mode: normal;
  width: 152px;
  height: 61px;
}
</style>
